/* For compatibility with older IE browsers, we create the origin
 from protocol and host instead of using location.origin. */
export const origin = [document.location.protocol, '//', document.location.host].join('');

export const BUTTON_TYPE = Object.freeze({
    Admin: 0,
    AddToCalendar: 1,
    LobbyQuestion: 2,
    Comments: 3,
    Questions: 4,
    Share: 5,
    Chapters: 6,
    Embed: 7,
    Statistics: 8,
    MoreMenu: 100,
});

export const userInteractionButtons = [
    newButton(BUTTON_TYPE.Admin, 'Admin tools', 'settings', 'vl-admin-only', true),
    newButton(
        BUTTON_TYPE.AddToCalendar,
        siteSettings.texts['Webcast_AddToCalendarHeader'],
        'calendar',
        '',
        true
    ),
    newButton(
        BUTTON_TYPE.LobbyQuestion,
        siteSettings.texts['Webcast_QnAHeader'],
        'questions',
        '',
        true
    ),
    newButton(
        BUTTON_TYPE.Comments,
        siteSettings.texts['Webcast_CommentsHeader'],
        'comments',
        '',
        true
    ),
    newButton(BUTTON_TYPE.Embed, 'Slido', 'questions', '', true),
    newButton(BUTTON_TYPE.Share, siteSettings.texts['Webcast_ShareHeader'], 'share', '', true),
    newButton(
        BUTTON_TYPE.Chapters,
        siteSettings.texts['Webcast_ChaptersHeader'],
        'chapters',
        '',
        true
    ),
    newButton(
        BUTTON_TYPE.Statistics,
        siteSettings.texts['Webcast_StatisticsHeader'],
        'statistics',
        '',
        true
    ),
    newButton(BUTTON_TYPE.MoreMenu, '', 'more', 'vl-more-menu-button', false),
];

function newButton(buttonType, title, iconClass, additionalClass, standardButton) {
    return {
        type: buttonType,
        isAvailable: false,
        isActive: false,
        hasNotification: false,
        additionalOnClick: null,
        title: title,
        icon: iconClass,
        additionalClass: additionalClass,
        isStandardButton: standardButton,
    };
}
